<template>
  <!--
    #3083 — avisos de qualidade da folha principal (`qualityWarnings` do detalhe). O emissor viu
    os mesmos avisos no envio e escolheu seguir; aqui o auditor sabe por onde começar a conferir.
    Mesma hierarquia âmbar do alerta de plantão alterado: informativo, não bloqueia.
  -->
  <div
    v-if="messages.length"
    data-testid="audit-quality-warnings"
    class="flex flex-col gap-2 rounded-lg border border-alert bg-alert/10 p-3"
  >
    <span
      class="w-fit rounded bg-alert px-2 py-[2px] text-[11px] font-bold uppercase leading-4 tracking-wide text-white"
    >
      Qualidade da foto
    </span>
    <p class="text-sm leading-[18px] text-textPrimary" data-testid="audit-quality-warnings-title">
      <span class="font-bold">{{ qualityWarningsTitle(messages.length) }}:</span>
      a folha foi enviada mesmo com os avisos abaixo. Confira essas páginas com atenção.
    </p>
    <ul class="list-disc pl-5 m-0 text-sm text-textPrimary">
      <li v-for="(message, index) in messages" :key="index" data-testid="audit-quality-warning">
        {{ message }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  qualityWarningsTitle,
  translateQualityWarnings
} from '@/components/designSystem/modals/AttendanceUploadModal/quality-warnings'

const props = defineProps<{ warnings?: string[] | null }>()

const messages = computed(() => translateQualityWarnings(props.warnings ?? []))
</script>
